import CardSection from '../sections/CardSection';
import InputField  from '../form/InputField';

export default function FeedbackSection({ propietario, tenedor, conductor }) {
    // Función auxiliar para mostrar nombres
    const displayName = person => {
        if (!person) return '';
        if (person.naturaleza === 'N') {
            return `${person.primerNombre || ''} ${person.primerApellido || ''}`.trim();
        }
        if (person.naturaleza === 'J') {
            return person.razonSocial || '';
        }
    };
    return (
        <CardSection icon="assignment" title="Asignaciones">
            <div className="row">
                <div className="col-md-6">
                    <InputField
                        id="fb-prop-nombre"
                        label="Nombre Propietario"
                        value={displayName(propietario)}
                        disabled
                    />
                </div>
                <div className="col-md-6">
                    <InputField
                        id="fb-prop-celular"
                        label="Celular Propietario"
                        value={propietario.celular || ''}
                        disabled
                    />
                </div>
                <div className="col-md-6">
                    <InputField
                        id="fb-ten-nombre"
                        label="Nombre Tenedor"
                        value={displayName(tenedor)}
                        disabled
                    />
                </div>
                <div className="col-md-6">
                    <InputField
                        id="fb-ten-celular"
                        label="Celular Tenedor"
                        value={tenedor.celular || ''}
                        disabled
                    />
                </div>
                <div className="col-md-6">
                    <InputField
                        id="fb-cond-nombre"
                        label="Nombre Conductor"
                        value={displayName(conductor)}
                        disabled
                    />
                </div>
                <div className="col-md-6">
                    <InputField
                        id="fb-cond-celular"
                        label="Celular Conductor"
                        value={conductor.celular || ''}
                        disabled
                    />
                </div>
            </div>
        </CardSection>
    );
}
